<div dx-resizable="{ handles: 'all', minWidth: 100, maxWidth: 800, minHeight: 600, maxHeight: 1000 }">
  <dx-scroll-view data-testid="pipeline-scroll-view" id="pipeline-div">
    <form #formElement (submit)="onSubmit($event)">
      <dx-form #dxForm
        data-testid="form"
        id="form"
        class="cards-wide"
        [formData]="pipelineData"
        [items]="formItems"
        [showValidationSummary]="true"
        [colCount]="formColCount"
        validationGroup="formGroup"
        (onContentReady)="onFormContentReady($event)">
        <div *dxTemplate="let section of 'fileUploadTemplate'">
          <app-file-upload
            data-testid="pipeline-file-upload"
            labelText=""
            selectButtonText="Browse or drop files here"
            (onFileUploadEventEmitter)="onFileUpload($event)"
            (onFileRemoveEventEmitter)="onFileRemove($event)">
          </app-file-upload>
        </div>
      </dx-form>
      <dx-load-panel data-testid="pipeline-load-panel" container=".cards-wide" [position]="{ of: '.content' }" [visible]="isLoading" [showPane]="true"></dx-load-panel>
    </form>
  </dx-scroll-view>
</div>